import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label, Input, FormFeedback } from 'reactstrap';

import api from "../../../api";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.saldos.categorias.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Categoria"}
                buttonTitle={"Ver Categoria"}
                buttonIcon={"fa fa-search fa-lg"}

                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la categoria</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input disabled={true} type="text" name="nombre"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Saldos/Categorias/Detail.js